import { routes } from '@wix/branding-client-lib';

const origins = {
  MY_LOGOS: 'mylogos',
  MY_LOGOS_SAVED: 'mylogossaved',
  ONBOARDING: 'onboarding',
  PRINTS: 'prints',
  THANK_YOU: 'thankYou',
  PACKAGE_PICKER: 'packagePicker',
  EDITOR: 'editor',
  BRAND_STUDIO: 'brandStudio',
  BRAND_STUDIO_SETUP_WIDGET: 'brandStudioSetupWidget',
  CART: 'cart',
  PRINTS_EDITOR: 'printsEditor',
  PRINT_SHOP: 'printShop',
  MORE_MERCH_POPUP: 'moreMerchPopup',
  CHENGE_LOGO_POPUP: 'changeLogoPopup',
  ARENA_SPLIT_PAGE: 'arenaSplitPage',
  MY_LOGOS_2: 'my_logos',
  BRAND_PACKAGE_PICKER: 'brandPackagePicker',
  BRAND_MAKER_STUDIO: 'brandMakerStudio'
};

export default origins;

export const getOriginByPath = pathname => {
  const stripSlash = url => url.replace(/\/$/, '');
  const path2SourceMap = {
    [stripSlash(routes.DASHBOARD_BRAND_STUDIO)]: origins.BRAND_STUDIO,
    [stripSlash(routes.PRINTS_EDITOR_BUSINESS_CARDS)]: origins.PRINTS_EDITOR,
    [stripSlash(routes.PRINTS_EDITOR)]: origins.PRINTS_EDITOR
  };
  return path2SourceMap[stripSlash(pathname)];
};
